import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { base64UrlDecode, base64UrlEncode,
  canActivate,
  capitalizeFirstLetter, error, extractSecondLevelBaseUrl, formatPrice, getAgeFromDob, getConsultationType, success } from '../../../../utils/utility';
import { DoctorDetails, Qualifications } from './../../../../shared/models/inventory.model';
import Panel from './../../../../shared/components/card/Panel';
import { Col, Divider, Row, Button, Popconfirm, Skeleton, Tooltip, Switch } from 'antd';
import { MONTH_YEAR_DATE_FORMAT, GUTTOR_SPACE, APPLICATION_ID, FETCH_FILE_BYTES, TOOLTIP_TEXT, INVENTORY_MESSAGE_CONSTANTS,
   authFeatureConstants } from '../../../../shared/constants/commonConstants';
import DoctorImage from './../../../../shared/components/doctImage/DoctorImage';
import moment from 'moment';
import { GUTTOR_SPACE_SMALL, INVENTROY_CONSTANTS, DOCTOR_GENDER } from './../../../../shared/constants/commonConstants';
import { FetchFileByteRequest, FetchFileByteResponse } from '../../../../shared/models/file.profile.model';
import SendRequest from './../../../../shared/services/sendRequest.service';
import SlotsCalendar from '../../shared/SlotsCalendar';
import { useHistory } from 'react-router-dom';
import { fetchDoctorsList, saveDoctorsList, setSelectedDoctorsList } from '../../../../store/actions/inventoryAction';
import { SaveDoctorDetails } from '../../shared/SaveDoctors';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import { ReactComponent as EditIcon } from '../../../../assets/images/svg/i_edit.svg';
import { isEmpty } from 'lodash';

const DoctorProfile = ({ match: { path, params: { id: doctorId } } }: any): ReactElement => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isAuthorized = canActivate(authFeatureConstants.EDIT_DOCTORS);
  const id = base64UrlDecode(doctorId);
  const doctorsDetailList = useSelector(({ inventory: { doctorsList } }: any): DoctorDetails[] => doctorsList);
  const [doctorDetails, setDoctorDetails] = useState(null as any);
  const [refreshStore, setRefreshStore] = useState(true);
  useEffect((): void => {
    if (Array?.isArray(doctorsDetailList) && !isEmpty(doctorsDetailList)) {
      const selectedDoctor = doctorsDetailList?.find((v: DoctorDetails): boolean => +v.id === +id);
      setDoctorDetails(selectedDoctor || null);
    }
    setTimeout((): void => {
      setRefreshStore(false);
    }, 1000);
  }, [doctorsDetailList]);

  useEffect((): any => {
    dispatch(setSelectedDoctorsList({}));
  }, [path]);

  useEffect((): void => {
    if (doctorDetails) {
      if (!doctorDetails?.imageUrl && doctorDetails?.personalDetail?.imageId) {
        const fileIdentifiers = [
          doctorDetails?.personalDetail?.imageId,
          doctorDetails?.professionalDetail?.doctorSignature,
        ]?.filter(Boolean);
        getFileBytes(fileIdentifiers);
      }
    }
  }, [doctorDetails]);

  const getFileBytes = async (imgIds: string[]): Promise<void> => {
    if (imgIds && imgIds?.length > 0) {
      const payload: FetchFileByteRequest = {
        applicationId: APPLICATION_ID,
        fileIdentifiers: imgIds,
      };
      const response: FetchFileByteResponse = await SendRequest.instance.post(`${process.env.REACT_APP_INVENTORY_API_BASE_URL}${FETCH_FILE_BYTES}`, payload);
      if (response && response.isSuccess) {
        setDoctorDetails({ ...doctorDetails, imageUrl: response?.fileDetails?.[0].fileBytes });
      }
    }
  };

  const getYearsAndMonth = (date: Date): string => {
    const a = moment();
    const b = moment(date);
    const age = moment.duration(a.diff(b));
    const years = age.years();
    const months = age.months();
    return (date && new Date(date).getFullYear() >= 1900) ? `(${years ? years + ' year(s)' : ''} ${months ? months : 0} month(s) experience)` : '';
  };

  const onEditProfile = (): void => {
    history.push(`${extractSecondLevelBaseUrl(path)}/${INVENTROY_CONSTANTS.editDoctorProfile}/${base64UrlEncode(id)}`);
  };

  const onDeleteProfile = async (): Promise<void> => {
    const doctorDetail: DoctorDetails = {
      isActive: !doctorDetails?.isActive, id: doctorDetails?.id, profileId: ApplicationDetail.instance.getProfileId(),
    };
    const response: any = await SaveDoctorDetails(doctorDetail);
    if (response && response?.isSuccess) {
      updateStore();
      success(doctorDetail.isActive ? INVENTROY_CONSTANTS.profileEnableSuccess : INVENTROY_CONSTANTS.profileDisableSuccess);
    } else if (response && response?.errorMessage) {
      error(response.errorMessage);
    } else {
      error(INVENTORY_MESSAGE_CONSTANTS.errorOccurred);
    }
  };

  const updateStore = (): void => {
    dispatch(saveDoctorsList(null));
    dispatch(fetchDoctorsList({}));
  };

  return (
    <div>
      <PageHeader colSize={18}
        backUrl={extractSecondLevelBaseUrl(path) + INVENTROY_CONSTANTS.doctorList}
        pageTitle={`${doctorDetails && doctorDetails?.personalDetail?.name ? doctorDetails?.personalDetail?.name : INVENTROY_CONSTANTS.doctorProfile}`}
        rightComponent={(): ReactElement =>
          <div className="text-right">
            {
              isAuthorized &&
              <Tooltip title={TOOLTIP_TEXT.edit} placement={'bottom'}>
                <Button type={'text'} onClick={onEditProfile} className="v-align-sub">
                  <EditIcon className="fill-primary" />
                </Button>
              </Tooltip>
            }
            <Popconfirm
              disabled={!isAuthorized}
              placement={'topRight'}
              title={doctorDetails?.isActive ? INVENTROY_CONSTANTS.disableConfirmMessage : INVENTROY_CONSTANTS.enableConfirmMessage}
              onConfirm={onDeleteProfile}
              okText="Yes"
              cancelText="No"
            >
              <Tooltip placement={'bottom'} title={!doctorDetails?.isActive ? TOOLTIP_TEXT.inActive : TOOLTIP_TEXT.active}>
                <Button type={'text'}>
                  <Switch disabled={!isAuthorized} size="small" checked={doctorDetails?.isActive} />
                </Button>
              </Tooltip>
            </Popconfirm>
            </div>
        }
      />
      <div className="ant-tabs-content-holder tab-custom-container doctor-profile">
        <Row gutter={GUTTOR_SPACE}>
          <Col md={16}>
            <Panel title={INVENTROY_CONSTANTS.profileDetails}>
              {(doctorDetails && !refreshStore) ? (
                <>
                  <Row gutter={GUTTOR_SPACE}>
                    <Col md={6} className="doct-img-lg" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                      <DoctorImage gender={doctorDetails?.personalDetail?.gender}
                       imgUrl={doctorDetails?.imageUrl} status={doctorDetails?.statusName}
                        customeClass={'doctor-avatar'} noVerifyIcon={true} />
                    </Col>
                    <Col md={14}>
                      {doctorDetails?.personalDetail?.name && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL}>
                            <Col md={6}><div className="label-title m-b-10">Full name</div></Col>
                            <Col md={12}><div className="label-value m-b-10 bold">
                              {capitalizeFirstLetter(doctorDetails?.personalDetail?.name)}
                            </div></Col>
                          </Row>
                        </>
                      )}
                      {doctorDetails?.personalDetail?.dateOfBirth && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL}>
                            <Col md={6}><div className="label-title m-b-10">Age</div></Col>
                            <Col md={12}>
                              <div className="label-value m-b-10 bold">
                                {getAgeFromDob(doctorDetails?.personalDetail?.dateOfBirth)}
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                      {doctorDetails?.personalDetail?.gender && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL}>
                            <Col md={6}><div className="label-title m-b-10">Gender</div></Col>
                            <Col md={12}>
                              <div className="label-value m-b-10 bold">
                                {
                                  (DOCTOR_GENDER[doctorDetails?.personalDetail?.gender] || INVENTROY_CONSTANTS.both)
                                }
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </Col>
                  </Row>
                  {doctorDetails?.professionalDetail && (
                    <>
                      <Divider plain={false} orientation="left" className="mb-lg">{INVENTROY_CONSTANTS.professionalDetails}</Divider>
                      {doctorDetails?.professionalDetail?.departmentName && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL}>
                            <Col md={6}><div className="label-title m-b-10">Department</div></Col>
                            <Col md={12}>
                              <div className="label-value m-b-10 bold">{doctorDetails?.professionalDetail?.departmentName}</div>
                            </Col>
                          </Row>
                        </>
                      )}
                      {doctorDetails?.professionalDetail?.qualifications &&
                        doctorDetails?.professionalDetail?.qualifications?.length > 0 && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL}>
                            <Col md={6}><div className="label-title m-b-10">Education</div></Col>
                            <Col md={12}>
                              <div className="label-value m-b-10 bold">
                                {doctorDetails?.professionalDetail?.qualifications.map((v: Qualifications, i: number): ReactNode => {
                                  return (
                                    <div key={i}>
                                      <div className="text-elipsis label-value m-b-10 bold">{v.qualificationName}</div>
                                      {v.additionalQualification &&
                                        <Tooltip title={v.additionalQualification}>
                                          <div className="text-elipsis label-value m-b-10 bold">
                                            {v.additionalQualification}
                                          </div>
                                        </Tooltip>
                                      }
                                    </div>
                                  );
                                })}
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                      {doctorDetails?.professionalDetail?.collegeName && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL} style={{ display: 'none' }}>
                            <Col md={6}><div className="label-title m-b-10">College name</div></Col>
                            <Col md={12}>
                              <div className="label-value m-b-10 bold">
                                {doctorDetails?.professionalDetail?.collegeName}
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                      {doctorDetails?.professionalDetail?.registrationNumber && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL}>
                            <Col md={6}><div className="label-title m-b-10">Registration No.</div></Col>
                            <Col md={12}>
                              <Tooltip title={doctorDetails?.professionalDetail?.registrationNumber}>
                                <div className="label-value m-b-10 bold text-elipsis">
                                  {doctorDetails?.professionalDetail?.registrationNumber}
                                </div>
                              </Tooltip>
                            </Col>
                          </Row>
                        </>
                      )}
                      {doctorDetails?.professionalDetail?.practiceStartedOn && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL}>
                            <Col md={6}><div className="label-title m-b-10">Practice started</div></Col>
                            <Col md={12}>
                              <div className="label-value m-b-10 bold">{moment(doctorDetails?.professionalDetail?.practiceStartedOn).format
                                (MONTH_YEAR_DATE_FORMAT)} <span className="label-title">
                                  {getYearsAndMonth(doctorDetails?.professionalDetail?.practiceStartedOn)}</span></div>
                            </Col>
                          </Row>
                        </>
                      )}
                      {doctorDetails?.professionalDetail?.awardsAndRecognition && (
                        <>
                          <Row gutter={GUTTOR_SPACE_SMALL}>
                            <Col md={6}><div className="label-title m-b-10">Awards & Recognition</div></Col>
                            <Col md={12}>
                              <div className="label-value m-b-10 bold">
                                {doctorDetails?.professionalDetail?.awardsAndRecognition}
                              </div>
                            </Col>
                          </Row>
                        </>
                      )}
                    </>
                  )}
                  {doctorDetails?.consultationDetail && (
                    <>
                      <Divider plain={false} orientation="left" className="mb-lg">{INVENTROY_CONSTANTS.consultationDetails}</Divider>
                      <Row gutter={GUTTOR_SPACE_SMALL}>
                        {doctorDetails?.consultationDetail?.consultationType !== 0 && (
                          <>
                            <Col md={6}><div className="label-title m-b-10">Consultation type</div></Col>
                            <Col md={6}>
                              <div className="label-value m-b-10 bold">
                                {getConsultationType(doctorDetails?.consultationDetail?.consultationType)}
                              </div>
                            </Col>
                          </>
                        )}
                        {(doctorDetails?.consultationDetail?.followUpCount > 0) && (
                          <>
                            <Col md={6}><div className="label-title m-b-10">Follow up fee waiver</div></Col>
                            <Col md={6}>
                              <div className="label-value m-b-10 bold">
                                {doctorDetails?.consultationDetail?.followUpCount + ' days'}
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                      <Row gutter={GUTTOR_SPACE_SMALL}>
                        {(doctorDetails?.consultationDetail?.consultationFee > 0) && (
                          <>
                            <Col md={6}><div className="label-title m-b-10">Consultation fee</div></Col>
                            <Col md={6}>
                              <div className="label-value m-b-10 bold">
                                {formatPrice(doctorDetails?.consultationDetail?.consultationFee, false)}
                              </div>
                            </Col>
                          </>
                        )}
                        {(doctorDetails?.consultationDetail?.discountedFee > 0) && (
                          <>
                            <Col md={6}><div className="label-title m-b-10">Discounted fee</div></Col>
                            <Col md={6}>
                              <div className="label-value m-b-10 bold">
                                {formatPrice(doctorDetails?.consultationDetail?.discountedFee, false)}
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                    </>
                  )}
                </>
              ) : (
                <>
                  <Row>
                    <Skeleton avatar={{
                      size: 'large', shape: 'circle',
                      style: {
                        height: '70px', width: '70px', marginRight: '16px', marginTop: '16px',
                      },
                    }} active={true} paragraph={{ rows: 2 }} />
                  </Row>
                  <Divider />
                  <Row>
                    <Col md={20}>
                      <Skeleton active={true} paragraph={{ rows: 2 }} />
                    </Col>
                  </Row>
                  <Divider />
                  <Row>
                    <Col md={20}>
                      <Skeleton active={true} paragraph={{ rows: 2 }} />
                    </Col>
                  </Row>
                </>
              )
              }
            </Panel>
          </Col>
          <Col md={8}>
            <SlotsCalendar title={INVENTROY_CONSTANTS.weeklySchedule} action={'Save'} data={doctorDetails} isReadOnly={true} />
          </Col>
        </Row>

      </div >
    </div >
  );
};

export default DoctorProfile;
